import React from "react";
import ResultsBlock from "theme/components/molecules/ResultsBlock";
import AutocompleteResults, {
  AutocompleteOption,
} from "theme/components/organisms/Autocomplete/AutocompleteResults";
import QueryResultItem from "./QueryResultItem";

const QueriesResults = (props) => {
  return (
    <ResultsBlock>
      <AutocompleteResults>
        {props.results.map((result, index) => (
          <AutocompleteOption
            key={`autocomplete-query-${index}`}
            id={result.query}
            path={result.query}
            selected={props.selected}
            onSelect={props.onSelect}
          >
            <QueryResultItem
              result={result}
              onClick={() => props.onQuerySelect(result.query)}
            />
          </AutocompleteOption>
        ))}
      </AutocompleteResults>
    </ResultsBlock>
  );
};

export default QueriesResults;
